// extracted by mini-css-extract-plugin
export var drawerPaper = "_1n-0";
export var itemCard = "_1n-1";
export var itemImage = "_1n-2";